// src/hooks/useNavigationHistory.jsx
import { useNavigate as useReactRouterNavigate } from 'react-router-dom';
// Removed createContext, useContext, useEffect, useRef, and useLocation
// as they are no longer needed for correct goBack behavior.

// The Provider is still necessary to wrap your app, but the logic inside 
// is now empty since the history stack is managed by React Router.
export const NavigationHistoryProvider = ({ children }) => {
    return (
        // The value prop is no longer necessary if you only use this for navigation.
        // I've removed the history ref.
        <div /* Using a fragment or div to fulfill the component structure */>
            {children}
        </div>
    );
};

export const useCustomNavigate = () => {
    const reactRouterNavigate = useReactRouterNavigate();

    const goBack = () => {
        // 🚨 THE FIX: Use -1 to step back in the browser's history stack.
        // This command does NOT add a new entry, fixing the loop/re-navigation issue.
        console.log("Navigating back one step using navigate(-1) to maintain history integrity.");
        reactRouterNavigate(-1); 
    };

    const navigate = (to, options) => {
        // Use the standard navigate for forward navigation
        reactRouterNavigate(to, options);
    };

    return { goBack, navigate };
};